import React from "react";
import { CollapseFAQ, H3, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import ContinueIcon from '../../TopbarContainer/Topbar/images/continue-icon.svg';
import BirdImage from '../images/BIRD - Sultan SMALL.jpg';

import css from '../PetSittingServicesPage.module.css';
import { birdFaq } from "./faqs";


const BirdPage = props => {
    return (
        <div className={css.rootOld}>
            <H3>
                Bird Sitting Services
            </H3>

            <p className={css.info}>
                Bird sitting is a specialised service that provides care for pet birds when their owners are away. From feeding to maintaining cages, bird sitters ensure your feathered friends remain healthy and happy in their familiar surroundings.
            </p>
            <br />
            <p className={css.info}>
                At HouseSit Match, we connect bird owners with trusted sitters who understand the unique needs of various bird species, offering peace of mind and expert care. Whether you have parrots, chickens, or exotic birds, HouseSit Match is here to help you find the ideal sitter to care for your pets with dedication and love.
            </p>

            <NamedLink
                className={css.ctaButtonOld}
                name="SignupPage"
            >
                <FormattedMessage id="PetSittingServicesPage.registerNow" />
                <img src={ContinueIcon} className={css.icon} />
            </NamedLink>

            <p className={css.subtitle}>
                What Is Bird Sitting?
            </p>

            <div className={css.imageContainer}>
                <img className={css.image} src={BirdImage} alt='travel is one of the benefits of house sitting for sitters' />
            </div>
            <br />
            <p className={css.info}>
                Bird sitting involves hiring a dedicated caregiver to look after your pet birds, ensuring their specific needs are met while you're away. Unlike traditional boarding, bird sitting keeps your birds in their comfortable environment, reducing stress and maintaining their daily routines.
            </p>
            <br />
            <p className={css.info}>
                From cleaning cages to providing enrichment activities, bird sitters offer a level of care that goes beyond basic supervision, ensuring your pets feel secure and well-attended.
            </p>

            <p className={css.subtitle}>
                Why Choose HouseSit Match for Bird Sitting?
            </p>

            <p className={css.info}>
                HouseSit Match is a trusted network for connecting bird owners with experienced sitters. Here's why we stand out:
            </p>

            <ul className={css.listNumbers}>
                <li>
                    <strong>Trusted Sitters: </strong>All sitters are verified to ensure the safety and well-being of your birds.
                </li>
                <li>
                    <strong>Global Reach: </strong>Connect with sitters from diverse locations, offering flexibility for various travel plans.
                </li>
                <li>
                    <strong>Affordable Rates: </strong>Save on expensive boarding costs while ensuring personalized care.
                </li>
                <li>
                    <strong>Tailored Matches: </strong>Our platform pairs you with sitters experienced in handling your bird species.
                </li>
                <li>
                    <strong>24/7 Support: </strong>Access our customer support team for assistance throughout the process.
                </li>
            </ul>

            <p className={css.subtitle}>
                The Benefits of Bird Sitting
            </p>
            <p className={css.info}>
                For bird owners:
            </p>

            <ul className={css.list}>
                <li>
                    <strong>Personalised Care: </strong>Your birds stay in their familiar environment with routines maintained.
                </li>
                <li>
                    <strong>Reduced Stress: </strong>Birds avoid the anxiety of travel or boarding in unfamiliar places.
                </li>
                <li>
                    <strong>Cost-Effective Solution: </strong>Avoid the high fees of professional boarding facilities.
                </li>
                <li>
                    <strong>Peace of Mind: </strong>Sitters provide attentive care, ensuring your bird's health and happiness.
                </li>
            </ul>

            <p className={css.info}>
                For those passionate about animals, pet sitting with HouseSit Match provides both a rewarding experience and the chance to travel affordably.
            </p>

            <ul className={css.list}>
                <li>
                    <strong>Free Accommodation: </strong>Stay in comfortable homes while caring for delightful feathered friends.
                </li>
                <li>
                    <strong>Enriching Experiences: </strong>Learn about different bird species and their unique care needs.
                </li>
                <li>
                    <strong>Flexible Opportunities: </strong>Choose assignments that fit your schedule and preferences.
                </li>
                <li>
                    <strong>Build Connections: </strong>Form lasting relationships with bird owners around the world.
                </li>
            </ul>

            <p className={css.subtitle}>
                Most Popular Bird Sitting Services
            </p>

            <ul className={css.listNumbers}>
                <li>
                    <strong>Parrot Sitting: </strong>Focused on maintaining diet, social interaction, and mental stimulation for these intelligent birds.
                </li>
                <li>
                    <strong>Chicken Sitting: </strong>Routine feeding, coop cleaning, and egg collection services to ensure happy, healthy hens.
                </li>
                <li>
                    <strong>Duck Sitting: </strong>Pond maintenance and care for ducks, including habitat cleaning and feeding.
                </li>
                <li>
                    <strong>Exotic Bird Sitting: </strong>Specialised care for rare species, catering to their unique dietary and environmental needs.
                </li>
                <li>
                    <strong>Small Bird Sitting: </strong>Tailored care for finches, canaries, and budgies, focusing on habitat cleanliness and interaction.
                </li>
            </ul>

            <p className={css.subtitle}>
                What Does a Bird Sitter Do?
            </p>

            <p className={css.info}>
                Bird sitters are responsible for:
            </p>

            <ul className={css.list}>
                <li>
                    Feeding birds according to specific dietary requirements.
                </li>
                <li>
                    Cleaning cages and maintaining hygienic living conditions.
                </li>
                <li>
                    Monitoring health and behavior for signs of distress or illness.
                </li>
                <li>
                    Providing social interaction and mental stimulation.
                </li>
                <li>
                    Administering medications if necessary, as directed by the owner.
                </li>
            </ul>


            <p className={css.subtitle}>
                How to Become a Bird Sitter
            </p>

            <p className={css.info}>
                Becoming a bird sitter through HouseSit Match is simple:
            </p>

            <ul className={css.listNumbers}>
                <li>
                    <strong>Create a Profile: </strong>
                    Sign up on our platform and detail your experience with bird care.
                </li>
                <li>
                    <strong>Verification Process: </strong>
                    Submit necessary documents for a secure vetting process.
                </li>
                <li>
                    <strong>Browse Assignments: </strong>
                    Search for bird sitting jobs that match your preferences.
                </li>
                <li>
                    <strong>Apply and Connect: </strong>
                    Communicate with bird owners to discuss responsibilities and build trust.
                </li>
                <li>
                    <strong>Start Sitting: </strong>
                    Provide exceptional care and establish your reputation as a trusted sitter.
                </li>
            </ul>

            <NamedLink
                className={css.ctaButtonOld}
                name="SignupPage"
            >
                <FormattedMessage id="PetSittingServicesPage.registerNow" />
                <img src={ContinueIcon} className={css.icon} />
            </NamedLink>

            <p className={css.subtitle}>
                Testimonials
            </p>

            <p className={css.info}>
                Example testimonials here
            </p>

            <p className={css.subtitle} style={{ marginBottom: 0 }}>
                FAQs
            </p>

            <CollapseFAQ
                list={birdFaq}
            />

            <p className={css.subtitle}>
                Find Your Bird Sitting Journey Today
            </p>

            <p className={css.info}>
                Ready to make your bird sitting experience seamless and rewarding? Whether you're a bird owner seeking trusted care or a sitter looking to explore exciting assignments, HouseSit Match connects you with the right people.
            </p>
            <br />
            <p className={css.info}>
                Bird owners can enjoy peace of mind knowing their feathered companions are in capable hands, cared for with dedication and love. Meanwhile, sitters can experience the joys of bonding with birds while enjoying free accommodation in unique locations.
            </p>
            <br />
            <p className={css.info}>
                <NamedLink name="SignupPage">Sign up on HouseSit Match</NamedLink> today to find your perfect match. It's quick, easy, and opens the door to stress-free bird care and rewarding opportunities!
            </p>

            <NamedLink
                className={css.ctaButtonOld}
                name="SignupPage"
            >
                <FormattedMessage id="PetSittingServicesPage.registerNow" />
                <img src={ContinueIcon} className={css.icon} />
            </NamedLink>
        </div>
    )
};

export default BirdPage;